import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, vModelRadio as _vModelRadio, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bdfe0968"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-el" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "fv-plugins-message-container text-start" }
const _hoisted_4 = { class: "fv-help-block" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "fv-plugins-message-container text-start" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { class: "fv-plugins-message-container text-start" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = {
  key: 3,
  class: "position-relative align-items-center"
}
const _hoisted_12 = { class: "fv-plugins-message-container text-start" }
const _hoisted_13 = { class: "fv-help-block" }
const _hoisted_14 = {
  key: 4,
  class: "position-relative align-items-center"
}
const _hoisted_15 = { class: "fv-plugins-message-container text-start" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = {
  key: 5,
  class: "position-relative align-items-center"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 checkbox-label" }, null, -1))
const _hoisted_19 = { class: "form-check form-check-custom form-check-solid mt-5 d-inline-flex align-items-center" }
const _hoisted_20 = { class: "fv-plugins-message-container text-start" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "form-check-label fw-bold" }
const _hoisted_23 = {
  key: 6,
  class: "col-lg-6 fv-row"
}
const _hoisted_24 = { class: "form-check-label fs-6" }
const _hoisted_25 = { key: 7 }
const _hoisted_26 = { class: "fv-plugins-message-container text-start" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = {
  key: 0,
  class: "fv-plugins-message-container text-start"
}
const _hoisted_29 = { class: "fv-help-block" }
const _hoisted_30 = { role: "alert" }
const _hoisted_31 = { key: 8 }
const _hoisted_32 = { class: "input-group d-flex align-items-center mb-3" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "w-40px" }
const _hoisted_35 = {
  key: 0,
  class: "fas fa-edit text-primary fs-6"
}
const _hoisted_36 = {
  key: 1,
  class: "fas fa-plus text-primary fs-6"
}
const _hoisted_37 = { class: "fv-plugins-message-container text-start" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = {
  key: 9,
  class: "position-relative align-items-center"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mb-2 checkbox-label" }, null, -1))
const _hoisted_41 = { class: "form-check form-check-custom form-check-solid me-10" }
const _hoisted_42 = ["onUpdate:modelValue", "name", "value", "checked"]
const _hoisted_43 = { class: "fv-plugins-message-container text-start" }
const _hoisted_44 = { class: "fv-help-block" }
const _hoisted_45 = { class: "form-check-label fw-bold" }
const _hoisted_46 = {
  key: 10,
  class: "operational-hours-section"
}
const _hoisted_47 = { class: "row" }
const _hoisted_48 = { class: "col-6" }
const _hoisted_49 = { class: "my-2" }
const _hoisted_50 = { class: "col-6" }
const _hoisted_51 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_52 = { class: "col-12" }
const _hoisted_53 = { class: "text-muted d-block" }
const _hoisted_54 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_55 = { class: "border rounded p-3" }
const _hoisted_56 = { class: "table mb-0" }
const _hoisted_57 = { scope: "col" }
const _hoisted_58 = { scope: "col" }
const _hoisted_59 = { scope: "col" }
const _hoisted_60 = { class: "fw-bold" }
const _hoisted_61 = {
  key: 0,
  class: "text-black"
}
const _hoisted_62 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_63 = { class: "d-flex flex-column" }
const _hoisted_64 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2 text-muted" }, "-", -1))
const _hoisted_66 = { class: "d-flex flex-column" }
const _hoisted_67 = {
  key: 0,
  class: "text-danger small mt-1"
}
const _hoisted_68 = { class: "form-check form-switch form-check-custom form-check-solid" }
const _hoisted_69 = ["id", "onUpdate:modelValue", "onChange"]
const _hoisted_70 = ["for"]
const _hoisted_71 = { class: "fv-plugins-message-container text-start" }
const _hoisted_72 = { class: "fv-help-block" }
const _hoisted_73 = { class: "modal-footer d-flex justify-content-between" }
const _hoisted_74 = ["data-kt-indicator"]
const _hoisted_75 = {
  key: 0,
  class: "indicator-label"
}
const _hoisted_76 = { class: "svg-icon svg-icon-3 me-0" }
const _hoisted_77 = {
  key: 1,
  class: "indicator-progress"
}
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_VZMultiSelect = _resolveComponent("VZMultiSelect")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_time_picker = _resolveComponent("el-time-picker")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Form = _resolveComponent("Form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_AddAddressModal = _resolveComponent("AddAddressModal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.modelViewValue,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modelViewValue) = $event)),
        title: _ctx.headerLabel,
        onClose: _ctx.discard,
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": _ctx.appendToBody
      }, {
        default: _withCtx(() => [
          _createVNode(_component_Form, {
            id: "kt_modal_new_target_form",
            onSubmit: _ctx.submit,
            ref: "formRef",
            class: "form",
            "validation-schema": _ctx.data.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                ref: "formScroll",
                class: _normalizeClass(["modal-body scroll-y bg-opacity-50 bg-light width-700", { 'scroll-select': _ctx.isMulitSelectField }])
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["row g-6 mb-3 me-n7 pe-2", { 'scroll-select': _ctx.isMulitSelectField }]),
                  id: "vz_add_edit_modal_scroll",
                  "data-kt-scroll": "true",
                  "data-kt-scroll-activate": "{default: false, lg: true}",
                  "data-kt-scroll-max-height": "auto",
                  "data-kt-scroll-dependencies": "#vz_add_edit_modal_header",
                  "data-kt-scroll-wrappers": "#vz_add_edit_modal_scroll",
                  "data-kt-scroll-offset": "300px"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataProp.model, (element, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: index,
                      class: _normalizeClass(["fv-row mt-0", element.type === 'date' ? 'col-md-6' : 'col-md-12'])
                    }, [
                      (
                    ['text', 'password'].includes(element.type) &&
                    _ctx.showOnForm(element)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["my-2", {
                      required: element.required && element.name != 'status',
                    }])
                            }, _toDisplayString(element.label), 3),
                            (element.name == 'status')
                              ? (_openBlock(), _createBlock(_component_Field, {
                                  key: 0,
                                  modelValue: _ctx.targetData[element.name],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                  name: "status"
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _createVNode(_component_el_input, _mergeProps(field, {
                                      modelValue: _ctx.targetData[element.name],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                      disabled: ""
                                    }), null, 16, ["modelValue", "onUpdate:modelValue"])
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"]))
                              : _withDirectives((_openBlock(), _createBlock(_component_Field, _mergeProps({
                                  key: 1,
                                  type: element.type,
                                  name: element.name,
                                  disabled: element.disabled,
                                  placeholder: element.placeholder,
                                  autocomplete: "off",
                                  rules: element.rules,
                                  value: element.value,
                                  "onUpdate:value": ($event: any) => ((element.value) = $event),
                                  modelValue: _ctx.targetData[element.name],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                  class: "form-control"
                                }, element.attrs), null, 16, ["type", "name", "disabled", "placeholder", "rules", "value", "onUpdate:value", "modelValue", "onUpdate:modelValue"])), [
                                  [_directive_maska, _ctx.maskForElement(element.name)]
                                ]),
                            _createElementVNode("div", _hoisted_3, [
                              _createElementVNode("div", _hoisted_4, [
                                _createVNode(_component_ErrorMessage, {
                                  name: element.name
                                }, null, 8, ["name"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    ['phoneNumber'].includes(element.type) &&
                    _ctx.showOnForm(element)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("label", {
                              class: _normalizeClass([{ required: element.required }, "my-2"])
                            }, _toDisplayString(element.label), 3),
                            _withDirectives(_createVNode(_component_Field, {
                              type: "text",
                              name: element.name,
                              disabled: element.disabled,
                              placeholder: element.placeholder,
                              autocomplete: "off",
                              rules: element.rules,
                              value: element.value,
                              "onUpdate:value": ($event: any) => ((element.value) = $event),
                              modelValue: _ctx.targetData[element.name],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                              class: "form-control"
                            }, null, 8, ["name", "disabled", "placeholder", "rules", "value", "onUpdate:value", "modelValue", "onUpdate:modelValue"]), [
                              [_directive_maska, ['(###) ##-####', '(###) ###-####']]
                            ]),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("div", _hoisted_7, [
                                _createVNode(_component_ErrorMessage, {
                                  name: element.name
                                }, null, 8, ["name"])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (element.type === 'textarea' && _ctx.showOnForm(element))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("label", {
                              class: _normalizeClass([{ required: element.required }, "my-2"])
                            }, _toDisplayString(element.label), 3),
                            _createVNode(_component_Field, {
                              name: element.name,
                              rules: element.rules,
                              modelValue: _ctx.targetData[element.name],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                              placeholder: element.placeholder
                            }, {
                              default: _withCtx(({ field }) => [
                                _createVNode(_component_el_input, _mergeProps(field, {
                                  modelValue: _ctx.targetData[element.name],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                  type: "textarea",
                                  rows: "2",
                                  disabled: element.disabled,
                                  name: element.name,
                                  placeholder: _ctx.t(element.label)
                                }), null, 16, ["modelValue", "onUpdate:modelValue", "disabled", "name", "placeholder"])
                              ]),
                              _: 2
                            }, 1032, ["name", "rules", "modelValue", "onUpdate:modelValue", "placeholder"]),
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createVNode(_component_ErrorMessage, {
                                  name: element.name
                                }, null, 8, ["name"])
                              ])
                            ])
                          ]))
                        : (element.type === 'date' && _ctx.showOnForm(element))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                              _createElementVNode("label", {
                                class: _normalizeClass([{ required: element.required }, "my-2"])
                              }, _toDisplayString(element.label), 3),
                              _createVNode(_component_Field, {
                                name: element.name,
                                rules: element.rules,
                                modelValue: _ctx.targetData[element.name],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event)
                              }, {
                                default: _withCtx(({ field }) => [
                                  _createVNode(_component_Datepicker, _mergeProps({
                                    placeholder: 
                        element.placeholder ?? _ctx.t('common.selectDate')
                      ,
                                    modelValue: _ctx.targetData[element.name],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                    enableTimePicker: false,
                                    format: _ctx.displayDate,
                                    "model-type": "yyyy-MM-dd",
                                    autoApply: true
                                  }, field, {
                                    teleport: "body",
                                    clearable: true,
                                    "min-date": 
                        element.name == 'startDate' ? _ctx.minDate : _ctx.minEndDate
                      
                                  }), null, 16, ["placeholder", "modelValue", "onUpdate:modelValue", "format", "min-date"])
                                ]),
                                _: 2
                              }, 1032, ["name", "rules", "modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_component_ErrorMessage, {
                                    name: element.name
                                  }, null, 8, ["name"])
                                ])
                              ])
                            ]))
                          : (element.type === 'list' && _ctx.showOnForm(element))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("label", {
                                  class: _normalizeClass([{ required: element.required }, "my-2"])
                                }, _toDisplayString(element.label), 3),
                                _createVNode(_component_Field, {
                                  name: element.name,
                                  rules: element.rules,
                                  modelValue: _ctx.targetData[element.name],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                  validateOnBlur: false,
                                  validateOnChange: false,
                                  validateOnInput: false
                                }, {
                                  default: _withCtx(() => [
                                    (element.multiSelect)
                                      ? (_openBlock(), _createBlock(_component_VZMultiSelect, {
                                          key: 0,
                                          modelValue: _ctx.targetData[element.name],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                          placeholder: element.placeholder,
                                          element: element,
                                          onChange: 
                        () => {
                          element.onValueChange
                            ? element.onValueChange(_ctx.targetData[element.name])
                            : null;
                          if (element.dependentFields) {
                            element.dependentFields.forEach((field) => {
                              _ctx.targetData[field] = [];
                              // set vee-validate error to null
                              // formRef?.value.setFieldError(
                              //   element.name,
                              //   null
                              // );
                            });
                          }
                        }
                      
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "element", "onChange"]))
                                      : _createCommentVNode("", true),
                                    (!element.multiSelect)
                                      ? (_openBlock(), _createBlock(_component_el_select, {
                                          key: 1,
                                          modelValue: _ctx.targetData[element.name],
                                          "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                          clearable: "",
                                          filterable: "",
                                          disabled: element.disabled,
                                          placeholder: element.placeholder,
                                          loading: element.loading ?? false,
                                          onChange: 
                        () => {
                          element.onValueChange
                            ? element.onValueChange(_ctx.targetData[element.name])
                            : null;
                          if (element.dependentFields) {
                            element.dependentFields.forEach((field) => {
                              _ctx.targetData[field] = '';
                              // set vee-validate error to null
                              // formRef?.value.setFieldError(
                              //   element.name,
                              //   null
                              // );
                            });
                          }
                        }
                      
                                        }, {
                                          default: _withCtx(() => [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(element.options, (option, index) => {
                                              return (_openBlock(), _createBlock(_component_el_option, {
                                                key: index,
                                                label: option.label,
                                                value: option.value
                                              }, null, 8, ["label", "value"]))
                                            }), 128))
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue", "disabled", "placeholder", "loading", "onChange"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["name", "rules", "modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createVNode(_component_ErrorMessage, {
                                      name: element.name
                                    }, null, 8, ["name"])
                                  ])
                                ])
                              ]))
                            : (element.type === 'checkbox' && _ctx.showOnForm(element))
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _hoisted_18,
                                  _createElementVNode("label", _hoisted_19, [
                                    _createVNode(_component_Field, {
                                      name: element.name,
                                      type: "checkbox",
                                      value: true,
                                      disabled: !_ctx.targetData.locationId,
                                      rules: element.rules,
                                      class: "form-check-input",
                                      modelValue: _ctx.targetData[element.name],
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event)
                                    }, null, 8, ["name", "disabled", "rules", "modelValue", "onUpdate:modelValue"]),
                                    _createElementVNode("div", _hoisted_20, [
                                      _createElementVNode("div", _hoisted_21, [
                                        _createVNode(_component_ErrorMessage, {
                                          name: element.name
                                        }, null, 8, ["name"])
                                      ])
                                    ]),
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(element.label), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                      (
                    element.type === 'checkbox2' &&
                    _ctx.showOnForm(element) &&
                    _ctx.viewName == 'sites' &&
                    _ctx.isHeadQuarterStaff(element)
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                            _createElementVNode("label", _hoisted_24, [
                              _createElementVNode("span", null, _toDisplayString(element.label), 1)
                            ]),
                            _createVNode(_component_Field, {
                              name: element.name,
                              type: "checkbox",
                              checked: _ctx.addAddressField,
                              onChange: _cache[0] || (_cache[0] = 
                      () => {
                        _ctx.addAddressField = !_ctx.addAddressField;
                      }
                    ),
                              rules: element.rules,
                              class: "form-check-input margin-l2",
                              modelValue: _ctx.targetData[element.name],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event)
                            }, null, 8, ["name", "checked", "rules", "modelValue", "onUpdate:modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      (
                    ['text2'].includes(element.type) &&
                    _ctx.showOnForm(element) &&
                    !_ctx.addAddressField
                  )
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createElementVNode("label", {
                              class: _normalizeClass(["my-2", {
                      required: element.required,
                    }])
                            }, _toDisplayString(element.label), 3),
                            _createVNode(_component_Field, _mergeProps({
                              type: element.type,
                              name: element.name,
                              disabled: element.disabled,
                              placeholder: element.placeholder,
                              autocomplete: "off",
                              rules: element.rules,
                              value: element.value,
                              "onUpdate:value": ($event: any) => ((element.value) = $event),
                              modelValue: _ctx.targetData[element.name],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                              class: "form-control mt-2"
                            }, element.attrs, {
                              onFocus: _cache[1] || (_cache[1] = 
                      () => {
                        _ctx.validationOnUserEmail = false;
                      }
                    )
                            }), null, 16, ["type", "name", "disabled", "placeholder", "rules", "value", "onUpdate:value", "modelValue", "onUpdate:modelValue"]),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("div", _hoisted_27, [
                                _createVNode(_component_ErrorMessage, {
                                  name: element.name
                                }, null, 8, ["name"])
                              ])
                            ]),
                            (_ctx.validationOnUserEmail)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                  _createElementVNode("div", _hoisted_29, [
                                    _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.t("common.userEmail") + " " + _ctx.t("common.isRequired")), 1)
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (element.type === 'address')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("label", {
                              class: _normalizeClass([{ required: element.required }, "my-2"])
                            }, _toDisplayString(element.label), 3),
                            _createElementVNode("div", _hoisted_32, [
                              _createVNode(_component_Field, _mergeProps({
                                type: element.type,
                                name: element.name,
                                disabled: element.disabled,
                                placeholder: element.placeholder,
                                autocomplete: "off",
                                rules: element.rules,
                                value: element.value,
                                "onUpdate:value": ($event: any) => ((element.value) = $event),
                                modelValue: _ctx.targetData[element.name],
                                "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                class: "form-control"
                              }, element.attrs), null, 16, ["type", "name", "disabled", "placeholder", "rules", "value", "onUpdate:value", "modelValue", "onUpdate:modelValue"]),
                              _createElementVNode("span", {
                                onClick: ($event: any) => (_ctx.showAddModal(element.value, true)),
                                class: _normalizeClass(["input-group-text", _ctx.dataProp.edit ? 'regular' : 'disabled']),
                                style: {"text-align":"center"}
                              }, [
                                _createElementVNode("span", _hoisted_34, [
                                  (_ctx.dataProp.edit)
                                    ? (_openBlock(), _createElementBlock("i", _hoisted_35))
                                    : (_openBlock(), _createElementBlock("i", _hoisted_36))
                                ])
                              ], 10, _hoisted_33)
                            ]),
                            _createElementVNode("div", _hoisted_37, [
                              _createElementVNode("div", _hoisted_38, [
                                _createVNode(_component_ErrorMessage, {
                                  name: element.name
                                }, null, 8, ["name"])
                              ])
                            ])
                          ]))
                        : (element.type === 'radio' && _ctx.showOnForm(element))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                              _hoisted_40,
                              _createElementVNode("label", _hoisted_41, [
                                _createVNode(_component_Field, {
                                  name: element.name,
                                  rules: element.rules,
                                  modelValue: _ctx.targetData[element.name],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                  type: "radio",
                                  value: element.value
                                }, {
                                  default: _withCtx(({ field }) => [
                                    _withDirectives(_createElementVNode("input", _mergeProps({
                                      class: "form-check-input",
                                      type: "radio",
                                      "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event),
                                      name: element.name,
                                      value: element.value,
                                      checked: element.value
                                    }, field), null, 16, _hoisted_42), [
                                      [_vModelRadio, _ctx.targetData[element.name]]
                                    ])
                                  ]),
                                  _: 2
                                }, 1032, ["name", "rules", "modelValue", "onUpdate:modelValue", "value"]),
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("div", _hoisted_44, [
                                    _createVNode(_component_ErrorMessage, {
                                      name: element.name
                                    }, null, 8, ["name"])
                                  ])
                                ]),
                                _createElementVNode("span", _hoisted_45, _toDisplayString(element.label), 1)
                              ])
                            ]))
                          : (
                    element.type === 'operationalHours' && _ctx.showOnForm(element)
                  )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("label", _hoisted_49, _toDisplayString(element.label), 1)
                                  ]),
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.toggleOperationalHours && _ctx.toggleOperationalHours(...args)), ["stop"])),
                                        class: _normalizeClass(["btn btn-sm btn-link p-0 text-primary", { 'text-danger': _ctx.operationalHoursEnabled }])
                                      }, _toDisplayString(_ctx.operationalHoursEnabled
                              ? `- ${_ctx.t("pages.site.removeOperationalHours")}`
                              : `+ ${_ctx.t("pages.site.addOperationalHours")}`), 3)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("small", _hoisted_53, _toDisplayString(element.placeholder), 1)
                                  ])
                                ]),
                                _createVNode(_component_Field, {
                                  name: element.name,
                                  rules: element.rules,
                                  modelValue: _ctx.targetData[element.name],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.targetData[element.name]) = $event)
                                }, {
                                  default: _withCtx(() => [
                                    (
                        _ctx.operationalHoursEnabled &&
                        _ctx.targetData[element.name]?.week
                      )
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                          _createElementVNode("div", _hoisted_55, [
                                            _createElementVNode("table", _hoisted_56, [
                                              _createElementVNode("thead", null, [
                                                _createElementVNode("tr", null, [
                                                  _createElementVNode("th", _hoisted_57, _toDisplayString(_ctx.t("pages.site.day")), 1),
                                                  _createElementVNode("th", _hoisted_58, _toDisplayString(_ctx.t("pages.site.hours")), 1),
                                                  _createElementVNode("th", _hoisted_59, _toDisplayString(_ctx.t("pages.site.closed")), 1)
                                                ])
                                              ]),
                                              _createElementVNode("tbody", null, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfWeek, (day, dayIndex) => {
                                                  return (_openBlock(), _createElementBlock("tr", {
                                                    key: day.value
                                                  }, [
                                                    _createElementVNode("td", _hoisted_60, _toDisplayString(day.label), 1),
                                                    _createElementVNode("td", null, [
                                                      (
                                      _ctx.targetData[element.name]?.week?.[
                                        day.value
                                      ]?.closed
                                    )
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.t("pages.site.closed")), 1))
                                                        : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                                            _createElementVNode("div", _hoisted_63, [
                                                              _createVNode(_component_el_time_picker, {
                                                                class: "starting-hour",
                                                                modelValue: 
                                          _ctx.targetData[element.name].week[
                                            day.value
                                          ].open
                                        ,
                                                                "onUpdate:modelValue": ($event: any) => ((
                                          _ctx.targetData[element.name].week[
                                            day.value
                                          ].open
                                        ) = $event),
                                                                format: "hh:mm A",
                                                                "value-format": "HH:mm",
                                                                placeholder: "From",
                                                                clearable: "",
                                                                size: "small",
                                                                "popper-class": "time-picker-popper"
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                              (
                                          _ctx.getOperationalHoursOpenError(
                                            day.value
                                          )
                                        )
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.getOperationalHoursOpenError(
                                            day.value
                                          )), 1))
                                                                : _createCommentVNode("", true)
                                                            ]),
                                                            _hoisted_65,
                                                            _createElementVNode("div", _hoisted_66, [
                                                              _createVNode(_component_el_time_picker, {
                                                                class: "ending-hour",
                                                                modelValue: 
                                          _ctx.targetData[element.name].week[
                                            day.value
                                          ].close
                                        ,
                                                                "onUpdate:modelValue": ($event: any) => ((
                                          _ctx.targetData[element.name].week[
                                            day.value
                                          ].close
                                        ) = $event),
                                                                format: "hh:mm A",
                                                                "value-format": "HH:mm",
                                                                placeholder: "To",
                                                                clearable: "",
                                                                size: "small",
                                                                "popper-class": "time-picker-popper"
                                                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                                              (
                                          _ctx.getOperationalHoursCloseError(
                                            day.value
                                          )
                                        )
                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_67, _toDisplayString(_ctx.getOperationalHoursCloseError(
                                            day.value
                                          )), 1))
                                                                : _createCommentVNode("", true)
                                                            ])
                                                          ]))
                                                    ]),
                                                    _createElementVNode("td", null, [
                                                      _createElementVNode("div", _hoisted_68, [
                                                        _withDirectives(_createElementVNode("input", {
                                                          class: "form-check-input",
                                                          type: "checkbox",
                                                          id: `closed-switch-${dayIndex}`,
                                                          "onUpdate:modelValue": ($event: any) => ((
                                        _ctx.targetData[element.name].week[day.value]
                                          .closed
                                      ) = $event),
                                                          onChange: ($event: any) => (
                                        _ctx.onClosedChange(day.value, element.name)
                                      )
                                                        }, null, 40, _hoisted_69), [
                                                          [_vModelCheckbox, 
                                        _ctx.targetData[element.name].week[day.value]
                                          .closed
                                      ]
                                                        ]),
                                                        _createElementVNode("label", {
                                                          class: "form-check-label",
                                                          for: `closed-switch-${dayIndex}`
                                                        }, null, 8, _hoisted_70)
                                                      ])
                                                    ])
                                                  ]))
                                                }), 128))
                                              ])
                                            ])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 2
                                }, 1032, ["name", "rules", "modelValue", "onUpdate:modelValue"]),
                                _createElementVNode("div", _hoisted_71, [
                                  _createElementVNode("div", _hoisted_72, [
                                    _createVNode(_component_ErrorMessage, {
                                      name: element.name
                                    }, null, 8, ["name"])
                                  ])
                                ])
                              ]))
                            : _createCommentVNode("", true)
                    ], 2))
                  }), 128))
                ], 2)
              ], 2),
              _createElementVNode("div", _hoisted_73, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
              () => {
                _ctx.discard();
                _ctx.$emit('close');
              }
            , ["stop"]))
                }, _toDisplayString(_ctx.t("common.close")), 1),
                _createElementVNode("button", {
                  "data-kt-indicator": _ctx.loading ? 'on' : null,
                  class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
                  type: "submit"
                }, [
                  (!_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_75, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.saveBtnLabel), 1),
                        _createElementVNode("span", _hoisted_76, [
                          _createVNode(_component_inline_svg, { src: "icons/duotune/arrows/arr064.svg" })
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.loading)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_77, [
                        _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
                        _hoisted_78
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_74)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ]),
        _: 1
      }, 8, ["modelValue", "title", "onClose", "append-to-body"])
    ]),
    _createVNode(_component_AddAddressModal, {
      showModal: _ctx.showAddressModal,
      data: _ctx.addressData,
      "onUpdate:modelValue": _ctx.updateShowModalVal,
      isEditable: _ctx.isEditMode,
      onSubmit: _ctx.addressSubmit
    }, null, 8, ["showModal", "data", "onUpdate:modelValue", "isEditable", "onSubmit"])
  ], 64))
}